import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Gift = function Gift(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.44922 10.4844C2.44922 11.5684 3.07422 12.0664 4.1582 12.0664H11.0625V6.55859H9.59766C8.10352 6.55859 7.24414 5.65039 7.24414 4.58594C7.24414 3.55078 7.9668 2.91602 9.02148 2.91602C10.1445 2.91602 11.0625 3.81445 11.0625 5.19141V6.55859H12.9277V12.0664H19.832C20.9258 12.0664 21.541 11.5684 21.541 10.4844V8.31641C21.541 7.10547 20.8672 6.55859 19.6465 6.55859H17.7324C18.2988 6.01172 18.6406 5.26953 18.6406 4.40039C18.6406 2.44727 17.0879 1.06055 15.1445 1.06055C13.6992 1.06055 12.4785 1.87109 12 3.31641C11.5215 1.87109 10.291 1.06055 8.8457 1.06055C6.90234 1.06055 5.34961 2.44727 5.34961 4.40039C5.34961 5.26953 5.69141 6.01172 6.25781 6.55859H4.34375C3.17188 6.55859 2.44922 7.10547 2.44922 8.31641V10.4844ZM14.9688 2.91602C16.0234 2.91602 16.7461 3.55078 16.7461 4.58594C16.7461 5.65039 15.8867 6.55859 14.3926 6.55859H12.9277V5.19141C12.9277 3.81445 13.8457 2.91602 14.9688 2.91602ZM3.79688 19.2539C3.79688 20.9141 4.7832 21.8223 6.45312 21.8223H11.0625V13.2578H3.79688V19.2539ZM12.9277 21.8223H17.5371C19.207 21.8223 20.1934 20.9141 20.1934 19.2539V13.2578H12.9277V21.8223Z"
  })));
};

Gift.displayName = 'Gift';
export default Gift;